<template>
  <lazy-component>
    <div class="ready">
      <p class="ready-mini">LET'S GET STARTED</p>
      <h2 class="ready-title">Ready to grow?</h2>
      <p v-if="$vuetify.breakpoint.smAndDown" class="ready-desc">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod tempor invidunt ut labore et dolore magna
      </p>
      <p v-else class="ready-desc">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
      </p>
      <v-btn class="hero-cta ready-btn" elevation="1">
        Get started with Triange today!
      </v-btn>
    </div>
  </lazy-component>
</template>

<script>
export default {};
</script>

<style lang="scss">
.ready {
  background-color: #6021ff;
  color: #fff;
  text-align: center;
  padding: 98px 0;
  &-mini {
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.49);
  }

  &-title {
    font-size: 56px;
    font-weight: 600;
    line-height: 1.167;
    margin-bottom: 12px;
  }

  &-btn {
    margin-top: 34px;
    height: 48px !important;
    background-color: #fff !important;
    max-width: 288px;

    span {
      color: #000;
      font-weight: 600;
      font-size: 16px !important;
      letter-spacing: 0;
    }
  }
}

@include smMax {
  .ready {
    padding: 62px 30px;
    &-title {
      font-size: 42px;
      margin-bottom: 20px;
    }
    &-btn {
      width: 100%;
      margin-bottom: 0;
      span {
        color: $primary-color;
        text-transform: none;
      }
    }
  }
}
</style>
